import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { persistor, store } from "./modules/app/mainReducer";
import { Router } from "./modules/app/router";
import { PersistGate } from "redux-persist/integration/react";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import "react-toastify/dist/ReactToastify.css";
import { Bounce, ToastContainer, toast } from "react-toastify";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

Sentry.init({
  dsn: "https://d6a7c1f0882e006367dcf29341865df5@o4506082865709056.ingest.sentry.io/4506082868854784",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ChakraProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>

        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          transition={Bounce}
        />
      </ChakraProvider>
    </PersistGate>
  </Provider>
);

// Service worker: deixa o app abrir sem sinal e avisa quando há versão nova.
// A troca só acontece quando o motorista toca no aviso, para não recarregar no meio de uma entrega.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const aguardando = registration.waiting;
    if (!aguardando) return;

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload();
    });

    toast.info("Nova versão do aplicativo disponível. Toque aqui para atualizar.", {
      autoClose: false,
      closeOnClick: true,
      onClick: () => aguardando.postMessage({ type: "SKIP_WAITING" }),
    });
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
